import type { FaireProductEntity } from "../../entity_types/product";

export const p_39xx77frpz: FaireProductEntity = {
  token: "p_39xx77frpz",
  type: "product",
  name: "Crystal Turtles",
  brandToken: "b_5wk9sqf7b2",
  brandName: "Chaotic Crystal Chick Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/048e9c599cd31feb4d5dd82c4aedeb1bb26180aafd7defd3681bac3c50603c91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f802c34625290f92381872f88e67425f2083b893814d21e8ac08062ab639abc.jpeg",
    "https://cdn.faire.com/fastly/e5cf47ced3c3ce91a9fec9a955f57c4c7f47b48c8a41a94641b293fde889eed7.jpeg",
    "https://cdn.faire.com/fastly/9faf12f2ebc71fce33d0292f982247be64a73b26f6f4a62429bca064d149e2ad.jpeg",
    "https://cdn.faire.com/fastly/bae84f237cbeb356651bd92858f4f1a0d0546edf8702634027910c46928b3fb0.jpeg",
  ],
  priceDollars: 7.48,
  description:
    "Choose the material of your fun crystal carving. Many of our carvings have multiple materials available and while we will try to update photos when new materials come in, there may be a gap in some updates. Please note most photos are the exact piece you will get, however sometimes we have duplicate shapes in the same material so there may be some variant in what you receive as these are natural crystals and minerals and no two pieces are exactly alike.\n",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:33.523Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
